/**
 * Backend Connection Indicator
 * Shows which backend the app is connected to (for testing/debugging)
 */
import React from 'react';
import { Badge } from '../ui/badge';

export function BackendIndicator() {
  const [apiUrl, setApiUrl] = React.useState<string>('');
  const [isVisible, setIsVisible] = React.useState(true);

  React.useEffect(() => {
    // Get the API URL from localStorage or use default
    const getApiUrl = () => {
      // Check if there's a hardcoded URL in the console logs
      const logs: string[] = [];
      const originalLog = console.log;
      
      console.log = (...args: any[]) => {
        logs.push(args.join(' '));
        originalLog.apply(console, args);
      };
      
      // Wait a bit for the API client to log its URL
      setTimeout(() => {
        const apiLog = logs.find(log => log.includes('API Base URL:'));
        if (apiLog) {
          const url = apiLog.split('API Base URL:')[1]?.trim();
          setApiUrl(url || 'Unknown');
        }
        console.log = originalLog;
      }, 100);
    };

    getApiUrl();

    // Auto-hide after 10 seconds
    const timer = setTimeout(() => setIsVisible(false), 10000);
    return () => clearTimeout(timer);
  }, []);

  if (!isVisible || !apiUrl) return null;

  const isLocalhost = apiUrl.includes('localhost') || apiUrl.includes('127.0.0.1');
  const isRemote = apiUrl.includes('172.235.19.18');

  return (
    <div 
      className="fixed top-2 right-2 z-50 flex items-center gap-2 bg-white/90 backdrop-blur-sm p-2 rounded-lg shadow-lg border border-gray-200"
      style={{ maxWidth: '400px' }}
    >
      <Badge variant={isLocalhost ? 'default' : isRemote ? 'secondary' : 'outline'}>
        {isLocalhost ? '🏠 Local' : isRemote ? '☁️ Remote' : '🌐 Custom'}
      </Badge>
      <span className="text-xs truncate" style={{ color: '#494949' }}>
        {apiUrl}
      </span>
      <button
        onClick={() => setIsVisible(false)}
        className="ml-auto text-gray-400 hover:text-gray-600"
        aria-label="Close"
      >
        ✕
      </button>
    </div>
  );
}